"use client";

import { useEffect, useRef } from "react";

export const STCursorFollower = () => {
  const dotRef = useRef(null);
  const circleRef = useRef(null);
  const mousePos = useRef({ x: 0, y: 0 });
  const dotPos = useRef({ x: 0, y: 0 });
  const circlePos = useRef({ x: 0, y: 0 });

  useEffect(() => {
    // run only on devices with mouse
    if (!window.matchMedia("(pointer: fine)").matches) return;

    const dot = dotRef.current;
    const circle = circleRef.current;

    const move = (e) => {
      mousePos.current = { x: e.clientX, y: e.clientY };
    };

    window.addEventListener("mousemove", move);

    const lerp = (start, end, factor) => start + (end - start) * factor;

    let rafId;
    const update = () => {
      // Smooth movement for dot
      dotPos.current.x = lerp(dotPos.current.x, mousePos.current.x, 0.4);
      dotPos.current.y = lerp(dotPos.current.y, mousePos.current.y, 0.4);

      // Smooth movement for circle
      circlePos.current.x = lerp(circlePos.current.x, mousePos.current.x, 0.15);
      circlePos.current.y = lerp(circlePos.current.y, mousePos.current.y, 0.15);

      if (dot) {
        dot.style.transform = `translate3d(${dotPos.current.x}px, ${dotPos.current.y}px, 0) translate(-50%, -50%) scale(${dot.dataset.scale || 1})`;
      }
      if (circle) {
        circle.style.transform = `translate3d(${circlePos.current.x}px, ${circlePos.current.y}px, 0) translate(-50%, -50%) scale(${circle.dataset.scale || 1})`;
      }

      rafId = requestAnimationFrame(update);
    };

    rafId = requestAnimationFrame(update);

    const targets = document.querySelectorAll(
      "a, button, input, textarea, [role='button']",
    );

    const onEnter = () => {
      if (circle) circle.dataset.scale = "1.5";
      if (dot) dot.dataset.scale = "0";
    };

    const onLeave = () => {
      if (circle) circle.dataset.scale = "1";
      if (dot) dot.dataset.scale = "1";
    };

    targets.forEach((el) => {
      el.addEventListener("mouseenter", onEnter);
      el.addEventListener("mouseleave", onLeave);
    });

    return () => {
      window.removeEventListener("mousemove", move);
      cancelAnimationFrame(rafId);
      targets.forEach((el) => {
        el.removeEventListener("mouseenter", onEnter);
        el.removeEventListener("mouseleave", onLeave);
      });
    };
  }, []);

  return (
    <>
      <div
        ref={dotRef}
        className="st-cursor-dot"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          pointerEvents: "none",
          zIndex: 9999,
          width: "6px",
          height: "6px",
          background: "var(--st-primary-color, #fff)",
          borderRadius: "50%",
          transition: "transform 0.2s ease-out",
        }}
      ></div>
      <div
        ref={circleRef}
        className="st-cursor-circle"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          pointerEvents: "none",
          zIndex: 9998,
          width: "40px",
          height: "40px",
          border: "1px solid var(--st-primary-color, #fff)",
          borderRadius: "50%",
          transition: "transform 0.3s ease-out",
        }}
      ></div>
    </>
  );
};
